import type { GzStatus, GzStatusKind } from '../../api/securiteeGravityZone'
import { escapeHtml } from '../../inventoree/format'

/** Culoarea etichetei: verde protejat, portocaliu probleme, rosu malware, gri fara agent. */
export const GZ_LABEL_CLASS: Record<GzStatusKind, string> = {
  protected: 'label-success',
  issues: 'label-warning',
  malware: 'label-danger',
  not_seen: 'label-info',
  no_agent: 'label-default',
  pending: 'label-primary',
}

/** Celula GravityZone din All devices (HTML, ca restul celulelor DataTable). */
export function gzCellHtml(status: GzStatus | undefined): string {
  if (!status) return '<span class="color-light-grey">—</span>'
  const reasons = status.reasons.length > 0 ? `<span class="gz-status-reasons">${escapeHtml(status.reasons.join(' · '))}</span>` : ''
  return `<span class="gz-status gz-status-${status.status}"><span class="label ${GZ_LABEL_CLASS[status.status]}">${escapeHtml(status.label)}</span>${reasons}</span>`
}
